import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useParams } from "react-router";
import SnackbarUtils from "../../../libs/SnackbarUtils";
import historyUtils from "../../../libs/history.utils";
import { serviceGetList } from "../../../services/index.services";
import nullImg from "../../../assets/img/null.png";
import { dataURLtoFile } from "../../../helper/Helper";
import {
  serviceCreateQuiz,
  serviceGetQuizDetails,
  serviceUpdateQuiz,
} from "../../../services/Quiz.service";

const initialForm = {
  title: "",
  description: "",
  image: null,
  start_date: "",
  client_id: "",
  update_reason: "",
  program_ids: [],
};

const useQuizCreateHook = ({ location }) => {
  const [form, setForm] = useState(JSON.parse(JSON.stringify(initialForm)));
  const [errorData, setErrorData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [listData, setListData] = useState({
    CLIENTS: [],
    PROGRAMS: [],
  });
  const [programList, setProgramList] = useState([]);
  const quizRef = useRef(null);
  const [image, setImage] = useState("");
  const { id } = useParams();
  const isDuplicate = location?.state?.is_duplicate || false;
  const Client = location?.state?.Client || "";
  const customerID = location?.state?.customerID || "";
  const Name = location?.state?.Name || [];

  useEffect(() => {
    if (!id && Client && Name) {
      setForm({
        ...form,
        client_id: Client,
        program_ids: Array.isArray(Name) ? Name : [Name],
        program_id: customerID,
      });
    }
  }, [id]);

  // useEffect(() => {
  //   if (!id ) {
  //     setForm({
  //       ...form,

  //       program_id: customerID,
  //     });
  //   }
  // }, [id]);

  useEffect(() => {
    const req = serviceGetList(["CLIENTS"]);
    req.then((res) => {
      if (!res?.error) {
        const data = res?.data;
        setListData(data);
      }
    });
  }, []);

  useEffect(() => {
    if (id) {
      serviceGetQuizDetails({ id }).then((res) => {
        if (!res?.error) {
          const data = res?.data?.details;
          const refData = data?.questions || [];
          quizRef.current.setData([...refData]);
          const obj = { id: data?.id };
          Object.keys({ ...initialForm })?.forEach((key) => {
            if (key === "client_id") {
              obj[key] = { ...data?.client, label: data?.client?.name };
            } else if (key === "program_ids") {
              obj[key] = data?.programs?.map((dT) => ({
                ...dT,
                label: dT?.name,
              }));
            } else if (key === "city_ids") {
              obj[key] = data?.cities?.map((dT) => ({ ...dT, label: dT.name }));
            } else {
              obj[key] = data[key] || "";
            }
          });
          setIsActive(data?.status === "ACTIVE");
          const isDuplicateData = isDuplicate
            ? {
                program_ids: [],
                start_date: "",
                client_id: "",
                // remote_path: data?.image || "",
                image: null,
                image_url: data?.image,
              }
            : {};
          setForm({
            ...obj,
            image: null,
            logo_url: data?.logo,
            ...isDuplicateData,
          });
          setImage(data?.image);
        }
      });
    }
  }, [id]);

  const getProgramList = useCallback(() => {
    if (form?.client_id) {
      const req = serviceGetList(["PROGRAMS"], {
        client_id: form?.client_id?.id,
      });
      req.then((res) => {
        if (!res?.error) {
          const resData = res?.data?.PROGRAMS;
          setProgramList([...resData]);
        }
      });
    }
  }, [form?.client_id]);

  useEffect(() => {
    if (form?.client_id) {
      getProgramList();
    }
  }, [form?.client_id]);

  const checkFormValidation = useCallback(() => {
    const errors = { ...errorData };
    let required = [
      "title",
      "description",
      "start_date",
      "client_id",
      "program_ids",
      // "update_reason"
    ];
    if (!id) {
      required.push(["image"]);
    }
    // else {
    //   required.push("update_reason");
    // }
    required.forEach((val) => {
      if (
        (!form?.[val] && parseInt(form?.[val]) !== 0) ||
        (Array.isArray(form?.[val]) && form?.[val]?.length === 0)
      ) {
        errors[val] = true;
      }
    });
    if (!form?.title?.trim()) {
      errors["title"] = true;
    }
    if (!form?.description?.trim()) {
      errors["description"] = true;
    }
    if (form?.start_date && !isActive) {
      const date = new Date(form?.start_date);
      const todayDate = new Date();
      date.setHours(0, 0, 0, 0);
      todayDate.setHours(0, 0, 0, 0);

      if (date.getTime() < todayDate.getTime()) {
        errors["start_date"] = true;
        SnackbarUtils.error("Date cannot be less than current Date");
      }
    }
    Object.keys(errors).forEach((key) => {
      if (!errors[key]) {
        delete errors[key];
      }
    });
    return errors;
  }, [form, errorData,isActive]);

  const removeError = useCallback(
    (title) => {
      const temp = JSON.parse(JSON.stringify(errorData));
      temp[title] = false;
      setErrorData(temp);
    },
    [setErrorData, errorData]
  );

  const changeTextData = useCallback(
    (text, fieldName) => {
      let shouldRemoveError = true;
      const t = { ...form };

      if (fieldName === "name") {
        if (text.length <= 80) {
          t[fieldName] = text;
        }
      } else if (fieldName === "start_date") {
        t[fieldName] = new Date(text);
      } else if (fieldName === "client_id") {
        t[fieldName] = text;
        t["program_ids"] = [];
        // getProgramList(text);
      } else if (fieldName === "program_ids") {
        const uniqueData = Object.values(
          text?.reduce((acc, item) => {
            acc[item?.id] = item;
            return acc;
          }, {})
        );
        t[fieldName] = uniqueData;
      } else {
        t[fieldName] = text;
      }
      setForm(t);
      shouldRemoveError && removeError(fieldName);
    },
    [removeError, form, setForm]
  );

  const submitToServer = useCallback(() => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      const fd = new FormData();
      Object.keys({ ...initialForm }).forEach((key) => {
        if (key === "client_id") {
          fd.append("client_id", form?.client_id?.id);
        } else if (key === "image") {
          if (form?.image) {
            fd.append(key, form?.image);
          }
        } else if (key === "update_reason") {
          if (id && !isDuplicate) {
            fd.append(key, form[key]);
          }
        } else if (key === "program_ids") {
          const getID = form?.program_ids?.map((val) => val?.id);
          fd.append("program_ids", JSON.stringify(getID));
        } else {
          fd.append(key, form[key]);
        }
      });
      if (form?.id && !isDuplicate) {
        fd.append("id", form?.id);
      }
      if (isDuplicate ) {
        fd.append("remote_image", form?.image_url);
      }
      const quizQuestion = quizRef.current.getData();
      quizQuestion.forEach((val) => {
        if (val?.question_images) {
          fd.append("question_images", val?.question_images);
        }
        // else {
        //   const file = dataURLtoFile(nullImg, "null.png");
        //   fd.append("question_images", file);
        // }
        // else {
        //   const file = dataURLtoFile(defaultImg, "null.png");
        //   fd.append("question_images", file);
        // }
        // else{
        //   fd.append("question_images", null);
        // }
      });
      fd.append("questions", JSON.stringify(quizQuestion));
      const serviceCall =
        form.id && !isDuplicate ? serviceUpdateQuiz : serviceCreateQuiz;
      serviceCall(fd).then((res) => {
        if (!res.error) {
          const message =
            form.id && !isDuplicate
              ? "Updated successfully"
              : "Created successfully";
          SnackbarUtils.success(message);
          historyUtils.goBack();
          // historyUtils.push(RouteName.CLAIMS_LIST);
        } else {
          SnackbarUtils.error(res?.message);
        }
        setIsSubmitting(false);
      });
    }
  }, [form, isSubmitting, setIsSubmitting]);

  const onBlurHandler = useCallback(
    (type) => {
      if (form?.[type]) {
        changeTextData(form?.[type].trim(), type);
      }
    },
    [changeTextData]
  );

  const handleSubmit = useCallback(
    async (status) => {
      const errors = checkFormValidation();
      const isIncludesValid = quizRef.current?.isValid();
      if (!isIncludesValid || Object.keys(errors).length > 0) {
        setErrorData(errors);
        return true;
      }
      submitToServer();
    },
    [checkFormValidation, setErrorData, submitToServer,isActive]
  );

  return {
    form,
    errorData,
    changeTextData,
    handleSubmit,
    listData,
    id,
    image,
    onBlurHandler,
    quizRef,
    isSubmitting,
    isActive,
    programList,
    isDuplicate,
  };
};

export default useQuizCreateHook;
